import React, { useState, useEffect } from "react";

const InlineSvgIcon = ({ src, size = 20 }) => {
  const [svgContent, setSvgContent] = useState(null);

  useEffect(() => {
    const fetchSvg = async () => {
      try {
        const response = await fetch(src);
        const rawSvg = await response.text();

   
        const updatedSvg = rawSvg
          .replace(/stroke-width="[^"]*"/g, 'stroke-width="1"')
          .replace(/stroke="[^"]*"/g, 'stroke="currentColor"')
          .replace(/<svg([^>]+)>/, `<svg$1 width="${size}" height="${size}">`);

        setSvgContent(updatedSvg);
      } catch (err) {
        console.error("SVG yüklenemedi:", err);
      }
    };

    fetchSvg();
  }, [src, size]);

  if (!svgContent) return null;

  return (
    <span
      dangerouslySetInnerHTML={{ __html: svgContent }}
      style={{
        width: size,
        height: size,
        display: "inline-block",
        verticalAlign: "middle",
     
      }}
    />
  );
};

export default InlineSvgIcon;
